import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-secondary)";

export default function IconActivity({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill={fill} d="M6 14a4 4 0 0 1-1.645-7.645 4.013 4.013 0 0 1 2-2 4 4 0 1 1 5.29 5.29 4.014 4.014 0 0 1-2 2A4 4 0 0 1 6 14zm5.993-5.76A3 3 0 0 0 10 3c-.89 0-1.688.391-2.238 1.008l-.014.002a4 4 0 0 1 4.243 4.265l.002-.036zm-2 2A3 3 0 0 0 8 5c-.89 0-1.687.391-2.237 1.008a4 4 0 0 1 4.224 4.314l.007-.083zM6 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
        </svg>
    );
}
